/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {ProviderMenuItem} from '@irian-ro/menu-provider-module';
import {Injectable, Optional, ViewChild, ViewContainerRef} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {NotificationUiPanelComponent} from "../components/notification-ui-panel/notification-ui-panel.component";
import {NotificationDataService} from "./notification-data.service";
import {DisplayNotificationUiPanelService} from './display-notification-ui-panel.service';

@Injectable()
export class NotificationUiMenuProvider {
  menuItems: Array<ProviderMenuItem> | undefined = undefined;

  menuItemsSubject: ReplaySubject<Array<ProviderMenuItem>> = new ReplaySubject();

  @ViewChild("dynamic", {read: ViewContainerRef, static: false}) view: ViewContainerRef | undefined = undefined;

  constructor(@Optional() private displayNotificationUiPanelService: DisplayNotificationUiPanelService,
              @Optional() private notificationDataService: NotificationDataService) {

  }

  getMenuItems(): ReplaySubject<Array<ProviderMenuItem>> {
    if (this.notificationDataService) {
      this.notificationDataService.getNotificationCount().subscribe(
        count => {

          this.menuItems = [];

          this.menuItems.push({
            icon: 'ui-icon-notifications',
            label: count.toString(),
            command: (event: any) => {
              if (this.displayNotificationUiPanelService) {
                this.displayNotificationUiPanelService.insertSadComponent(NotificationUiPanelComponent);
              } else {
                throw new Error('Provide a DisplayNotificationUiPanelService instance');
              }
            },
            weight: '95'

          });
          this.menuItemsSubject.next(this.menuItems);
        }
      )
    } else {
      throw new Error('Provide a NotificationDataService instance')
    }

    return this.menuItemsSubject;

  }
}
